import { useState } from "react";
import styled from "styled-components";
import { FaPen, FaWindowMinimize, FaWindowMaximize, FaTimes } from "react-icons/fa";
import { EditText } from 'react-edit-text';
import 'react-edit-text/dist/index.css';

const AccordionContainer = styled.div`
  padding-left: 10px;

  &:first-child > .acc-top {
    border-top: solid 1px #e9ebe8;
  }

  &:last-child > .acc-top {
    border-bottom: solid 1px #e9ebe8;
  }

  &:nth-child(even) > .acc-top {
    background: #e9ebe8;
  }

  transform: width
`

const AccordionBanner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;

  > div > div > div.edit-text {
    font-weight: 700;
    min-height: 0;
  }

  > div > div > div.edit-text.subtitle {
    font-weight: 300;
    min-height: 0;
  }

  > div > input[type=text] {
    font-weight: 700;
    font-size: 1em;
    min-height: 0;
    background-color: transparent;
  }

  > div > input[type=text]:focus {
    font-weight: 300;
    font-size: 1em;
    min-height: 0;
    background-color: transparent;
  }
`

const TitleContainer = styled.div`
  display: flex;
  flexDirection: row;
`;

const Button = styled.button`
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  cursor: pointer;
  color: ${props => props.changeColor ? "#3e3f40" : "#B9B9B9"};
  background-color: transparent;
  font-size: 1.3em;
  transition: color 0.3s;
  margin-right: 8px;
`;

const ButtonHousing = styled.div`
  display: flex;
  flex-direction: row;

`

const Accordion = ({title, subtitle, fieldSetter, fieldSetter2, deleteMethod, children}) => {
  const [accordionOpened, setAccordionOpened] = useState(false);
  const [hovered, setHovered] = useState(false);

  const [minButtonHovered, setMinButtonHovered] = useState(false);
  const [deleteButtonHovered, setDeleteButtonHovered] = useState(false);

  const toggleAccordionOpened = () => {
    setAccordionOpened(!accordionOpened)
  }

  return(
    <AccordionContainer
      open={accordionOpened}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <AccordionBanner className="acc-top">
        <TitleContainer>
          <EditText
            className="edit-text"
            value={title}
            onChange={e => fieldSetter(e)}
            showEditButton={hovered}
            editButtonContent={<FaPen/>}
            editButtonProps={{style: {backgroundColor: "transparent", cursor: "pointer"}}}
          />
          { typeof(subtitle) === "undefined" ? null :
          <EditText
            className="edit-text subtitle"
            value={subtitle}
            onChange={e => fieldSetter2(e)}
            showEditButton={hovered}
            editButtonContent={<FaPen/>}
            editButtonProps={{style: {backgroundColor: "transparent", cursor: "pointer"}}}
          />
          }
        </TitleContainer>
        <ButtonHousing>
          <Button
            type="button"
            changeColor={minButtonHovered}
            onClick={toggleAccordionOpened}
            onMouseEnter={() => setMinButtonHovered(true)}
            onMouseLeave={() => setMinButtonHovered(false)}
          >
            {accordionOpened ? <FaWindowMinimize/> : <FaWindowMaximize/>}
          </Button>
          <Button
            type="button"
            changeColor={deleteButtonHovered}
            onClick={deleteMethod}
            onMouseEnter={() => setDeleteButtonHovered(true)}
            onMouseLeave={() => setDeleteButtonHovered(false)}
          >
            <FaTimes/>
          </Button>
        </ButtonHousing>
      </AccordionBanner>
      <div>
        {accordionOpened ? children : null}
      </div>
    </AccordionContainer>
  )

}

export default Accordion;
